import { mapState, mapActions } from 'vuex'
import config from '../../../../package.json'
import cache, { EXTERNAL_USERID_KEY } from '../../../common/cache'
import util from '../../../common/util'

export default {
  computed: {
    ...mapState({
      userInfo: state => state.aftersales.userInfo,
      carList: state => state.aftersales.carList
    }),
    // 埋点数据字段  页面来源
    sourcePage() {
      return cache.getPrevActivePage()
    }
  },
  methods: {
    ...mapActions('aftersales', ['GET_USERINFO_BY_MOBILE', 'GET_USER_CAR_LIST', 'GET_USERINFO_BY_EXID']),
    // 更新外部联系人信息
    async updateExternalUserInfo(data) {
      // 更改的手机号与当前用户手机号相同
      if (this.userInfo.mobile_number === data.mobile_number) {
        this.$cvux.toast.show({ type: 'text', width: '12em', text: '当前客户已绑定此手机号' })
        return false
      }
      const wx = await this.$wechat.promise
      // 获取外部联系人Id
      const externalUserId = await wx.getCurExternalUserId()
      this.switchLoading({ status: true, text: '加载中...' })

      const { code, message } = await this.$rest.aftersales.updateExternalUser({
        external_userid: externalUserId,
        ...data
      })
      this.switchLoading({})
      if (code !== 0) {
        const param = { type: 'text', width: '', text: message }
        // code === 1002 联系人不存在
        if (code === 1002) {
          param.width = '24em'
          param.text = '未找到此客户，请在“立新出行DOS系统”增加客户'
        }
        this.$cvux.toast.show(param)
        return false
      }

      const _externalUserId = data.external_userid || externalUserId

      cache.setSessionData(EXTERNAL_USERID_KEY, _externalUserId)

      // 更新用户信息 及用户名下车辆信息
      await this.regainUserInfo(_externalUserId)

      return true
    },
    // 重新获取用户信息 及 用户车辆信息
    async regainUserInfo(externalUserId) {
      const result = await this.GET_USERINFO_BY_EXID(externalUserId)
      if (!result) return
      await this.GET_USER_CAR_LIST(this.userInfo.id)
    },
    /**
     * 根据用户名下车辆信息进行跳转页面
     * @returns 是否进行页面跳转
     */
    handleToCarPage() {
      // 只有一辆车跳转详情页，否则跳转列表页
      const route = { name: 'aftersalesCarList', query: {} }
      if (this.carList.length) {
        if (this.carList.length === 1) {
          route.name = 'aftersalesCarInfo'
          route.query.carId = this.carList[0].id
          route.query.mobile = this.userInfo.mobile_number
        } else {
          if (this.userInfo.default_car_id && this.carList.find(item => this.userInfo.default_car_id === item.id)) {
            route.name = 'aftersalesCarInfo'
            route.query.carId = this.userInfo.default_car_id
            route.query.mobile = this.userInfo.mobile_number
          }
        }
      }
      const diffRoute = this.$route.name !== route.name
      diffRoute && this.$router.push(route)
      return diffRoute
    },
    // 获取用户信息 及 用户车辆数据
    async getInitData() {
      return this.$wechat.promise.then(async wx => {
        // 用户信息不存在， 重新获取
        if (!this.userInfo.id) {
          const entranceEnv = await wx.getEntranceEnv()
          if (entranceEnv === 'group_chat_tools') {
            const chatId = await wx.getCurExternalChat()
            // 获取群内外部联系人列表
            const res = await this.$rest.aftersales.getOwnerServiceGroupCustomerList(chatId)()
            if (res.code) return
            // 判断群是否是服务群
            const { current_customer } = res.data
            if (current_customer && current_customer.external_userid) {
              // 缓存群对应的外部联系人ID
              cache.setSessionData(EXTERNAL_USERID_KEY, current_customer.external_userid)
            }
          }

          const externalUserId = await wx.getCurExternalUserId()
          const result = await this.GET_USERINFO_BY_EXID(externalUserId)
          if (!result) return
        }

        if (!this.carList.length) {
          await this.GET_USER_CAR_LIST(this.userInfo.id)
        }
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
    },
    // 获取埋点数据公共字段 运行版本号  平台标识  服务顾问id  门店id
    getCommonTraceFields() {
      const device_type = util.getDeviceType()
      const dict = {
        'Mac OS': 1,
        'Windows': 1,
        'Android': 2,
        'IOS': 2,
        'unknown': 0
      }
      return new Promise(resolve => {
        this.$store.state.promiseAuth.then((auth) => {
          resolve({
            version: config.version, // 版本号
            device_type: dict[device_type], // 平台标识
            employee_id: auth.id, // 用户id
            store_id: this.$store.state.customized.store_config.store_id // 用户门店
          })
        })
      })
    }
  }
}
